import React, { useEffect, useRef } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnleashYourPower() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll();
  const {
    ref: taglineRef,
    isVisible: taglineVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.8;
    }
  }, []);
  return <section data-section-id="38045" id="cinematic-mountain-hero" className="dark bg-background text-foreground relative h-screen w-full overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0">
        <video ref={videoRef} autoPlay muted loop playsInline className="h-full w-full object-cover grayscale contrast-150 brightness-50" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570849/img/hero_poster_action.png">
          <source src="/videos/action_fitness_hero.mp4" type="video/mp4" />
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570849/img/hero_fallback_action.png" alt="Rugged mountain peaks at dawn" className="h-full w-full object-cover" />
        </video>
        
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,#050505_95%)] opacity-95 z-10" />
        
        {}
        <div className="absolute inset-0 bg-black/40 z-10" />
      </div>

      {}
      <div className="relative z-20 flex flex-col items-center justify-center text-center px-4 w-full max-w-[100vw]">
        
        {}
        <h1 ref={headlineRef} className={`
            font-sans font-black tracking-tighter uppercase
            text-[7vw] leading-[0.9]
            bg-gradient-to-b from-white to-slate-300 bg-clip-text text-transparent
            transition-all duration-1000 ease-out transform
            ${headlineVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-10 scale-95"}
          `}>STAND TOGETHER.&nbsp;<br /><span className="text-primary" data-ast-id="f:/src/pages/Home/sections/UnleashYourPower.tsx|sig:p8yc2l" data-ast-start="2360" data-ast-end="2529" contenteditable="false" style={{}}>FIGHT THE DEMONS</span>.<br />PROTECT OUR OWN.</h1>

        {}
        <p ref={taglineRef} className={`
            mt-6 text-lg md:text-xl font-medium tracking-widest text-slate-400 uppercase max-w-3xl
            transition-all duration-1000 delay-300 ease-out transform
            ${taglineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
          `}>
          A veteran and first responder owned movement dedicated to supporting those battling the invisible war.
        </p>

        {}
        <div ref={ctaRef} className={`
            mt-12
            transition-all duration-1000 delay-500 ease-out transform
            ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
          `}>
          <Button asChild size="lg" className="
              relative overflow-hidden
              bg-primary text-primary-foreground border-none
              text-xl font-bold px-10 py-8 h-auto rounded-none
              hover:bg-primary/90
              shadow-[0_0_20px_rgba(179,0,0,0.5)]
              hover:shadow-[0_0_40px_rgba(179,0,0,0.8)]
              transition-all duration-300
              group
            ">
            <Link to="/TheRallyPointPage">
              <span className="relative z-10 flex items-center gap-3">
                SHOP OUR GEAR
                <ArrowRight className="w-6 h-6 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
              
              {}
              <span className="absolute inset-0 rounded-none bg-white/10 animate-[ping_3s_cubic-bezier(0,0,0.2,1)_infinite] opacity-0 group-hover:opacity-30" />
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 animate-bounce text-white/30">
        <div className="w-[1px] h-16 bg-gradient-to-b from-transparent via-white/30 to-transparent" />
      </div>
    </section>;
}